import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, RotateCcw } from "lucide-react";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { SolutionCard } from "./SolutionCard";
import { HowItWorksModal } from "./HowItWorksModal";
import { TiktokLivePanel } from "./TiktokLivePanel";

export const Results = ({ onRestart, compact, onNavigate }) => {
  const { state } = useAdvisor();
  const [info, setInfo] = useState(null);
  const nav = useNavigate();
  const recs = state.recommendations;
  const isTT = state.business?.key === "tiktok";
  const title = isTT ? "TikTok LIVE üçün tövsiyələr" : state.business?.key === "other" ? "Biznesiniz üçün tövsiyələr" : `${state.business?.label} biznesiniz üçün tövsiyələr`;

  return (
    <div data-testid="advisor-results">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <div className="adv-eyebrow mb-2">Nəticə</div>
          <h2 className="text-2xl sm:text-4xl font-semibold text-[#F3EEE4] tracking-tight" data-testid="results-title">{title}</h2>
          <p className="text-[#a9a398] mt-1" data-testid="results-count">{recs.length} uyğun həll tapdıq</p>
        </div>
        <button onClick={onRestart} className="text-[#a9a398] hover:text-[#F3EEE4] text-sm flex items-center gap-1 shrink-0" data-testid="btn-restart-advisor">
          <RotateCcw className="h-4 w-4" /> Yenidən
        </button>
      </div>

      {isTT && <TiktokLivePanel onNavigate={onNavigate} />}

      <div className={`grid grid-cols-1 gap-4 ${compact ? "" : "md:grid-cols-2 lg:grid-cols-3"}`}>
        {recs.map((s, i) => <SolutionCard key={s.slug} sol={s} index={i} onInfo={setInfo} />)}
      </div>

      <div className={`adv-card mt-8 p-6 sm:p-8 flex flex-col ${compact ? "" : "sm:flex-row sm:items-center"} justify-between gap-4 bg-gradient-to-r from-[#D6AD62]/15 to-[#B98B42]/5`}>
        <div>
          <h3 className="text-xl sm:text-2xl font-bold">Bunu mənim biznesim üçün hazırlayın</h3>
          <p className="text-[#a9a398] text-sm mt-1">Bəyəndiyiniz həlləri layihənizə əlavə edin və pulsuz qiymət təklifi alın.</p>
        </div>
        <button className="adv-btn shrink-0" onClick={() => { onNavigate?.(); nav("/advisor/layihe"); }} disabled={!state.selected.length} data-testid="btn-build-for-me">
          Layihəmə bax <ArrowRight className="h-5 w-5" />
        </button>
      </div>

      <HowItWorksModal sol={info} onClose={() => setInfo(null)} />
    </div>
  );
};
